import {useMutation} from 'react-query';
import {toast} from 'react-toastify';
import {deleteUserChat} from 'services/farm/chatList';

const useDeleteChat = ({refetch}: IDeleteChatUserWholeSaler) => {
  const {isLoading, mutate} = useMutation({
    mutationFn: (guid: string) => {
      return deleteUserChat({
        guid,
      });
    },
    onSuccess: () => {
      refetch();
    },
    onError: () => {
      toast.error('مشکلی در حذف چت پیش آمده');
    },
  });
  return {isLoading, mutate};
};
export default useDeleteChat;
